import React from 'react';
import styles from './Badge.module.css';

const variants = {
  neutral: styles.neutral,
  accent: styles.accent,
  success: styles.success,
  warning: styles.warning,
  danger: styles.danger,
};

export default function Badge({ children, variant = 'neutral', className = '', ...rest }) {
  return (
    <span className={`${styles.badge} ${variants[variant] || styles.neutral} ${className}`} {...rest}>
      {children}
    </span>
  );
}
